import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { toast as toastFunction } from 'react-toastify';
import { Alert } from '../../../primitives/Alert/index.js';
export const useToast = options => {
  return ({
    message,
    caption,
    variant = 'info',
    ...toastProps
  }) => {
    toastFunction(_jsx(Alert, {
      caption: caption,
      variant: variant,
      children: message
    }), {
      type: variant,
      ...options,
      ...toastProps
    });
  };
};